"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PageTemplateController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/pageTemplate',
            edit: '/v1/pageTemplate/:objectId',
            delete: '/v1/pageTemplate/:objectId',
        };
    }
}
exports.default = PageTemplateController;
